module.exports = __webpack_public_path__ + "static/media/dompe-512.d931e125.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dompe-512.png
// module id = 765
// module chunks = 0